<template>
  <aside class="w-full xl:max-w-[500px] lg:max-w-[400px] shrink-0 bg-white flex flex-col grow relative z-20">
    <!-- Steps -->
    <!-- <StepNavigation v-if="pod.currentStep < 11" /> -->

    <!-- Options wrapper -->
    <div ref="sideBar" class="relative flex flex-col w-full h-0 overflow-y-auto bg-white grow branded-scroll">
        <TransitionGroup name="top">
        <StepSummary v-if="configLoaded" :hideDetails="true" />
        </TransitionGroup>
    </div>

    <div
      class="sticky bottom-0 flex flex-col gap-2 px-4 py-2 bg-white shadow lg:gap-4 lg:p-4">
      <div class="flex w-full gap-4">
        <a
        href="/"
          class="button-orange-contained flex gap-[10px] items-center w-full justify-center">
          <span>Ontwerp je eigen pod</span>
        </a>
      </div>
    </div>
  </aside>
</template>
<script setup lang="ts">
import { usePodStore } from '@/stores/pod'
import StepSummary from '@/components/Step/StepSummary.vue'
import { ref } from 'vue'
import { watch } from 'vue'

const pod = usePodStore()

const configLoaded = ref(false)

watch(() => pod.options.podtype, () => {
  if (pod.options.podtype !== null) {
    setTimeout(() => { configLoaded.value = true }, 500)
  }
})


</script>
<style scoped lang="scss">
.top-enter-active,
.top-leave-active {
  transition:
    transform 0.3s ease-in,
    opacity 0.3s ease-in;
}

.top-enter-from,
.top-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
